var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-dialog', {
    model: {
      value: _vm.isShownDialog,
      callback: function callback($$v) {
        _vm.isShownDialog = $$v;
      },
      expression: "isShownDialog"
    }
  }, [_c('dialog-default-layout', [_c('div', {
    staticClass: "confirmation-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('request.additional.data.from.viewers')))])]), _c('div', {
    staticClass: "confirmation-message",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('for.correctly.work.widget.we.will.add.fields')))]), _c('ul', {
    staticClass: "confirmation-feild-list"
  }, _vm._l(_vm.senderFields, function (field) {
    return _c('li', {
      key: field.name,
      staticClass: "confirmation-feild-item"
    }, [_vm._v(" " + _vm._s(_vm.$t(field.value)) + " ")]);
  }), 0), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('can.disable.fields.after.stream', {
        getSettingsPaymentLink: _vm.getSettingsPaymentLink
      }))
    }
  })]), _c('div', {
    staticClass: "confirmation-control-buttons",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "confirmation-control-active"
  }, [_c('cs-button', {
    attrs: {
      "width": "100%"
    },
    on: {
      "click": _vm.onConfirmation
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('turn.on')) + " ")])], 1), _c('div', {
    staticClass: "confirmation-control-cancel"
  }, [_c('cs-button', {
    attrs: {
      "width": "100%",
      "type": "transparent"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }